var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.4,
    height: 19.374,
    viewBox: "0 0 17.4 19.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6607",
    "data-name": "Group 6607",
    transform: "translate(-1707.3 -452.313)",
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7819",
    "data-name": "Path 7819",
    d: "M4,7H19.8",
    transform: "translate(1704.1 450.063)",
    fill: "none",
    stroke: "#1a3173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7820",
    "data-name": "Path 7820",
    d: "M10,11v5.925",
    transform: "translate(1704.025 450.012)",
    fill: "none",
    stroke: "#1a3173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7821",
    "data-name": "Path 7821",
    d: "M14,11v5.925",
    transform: "translate(1703.975 450.012)",
    fill: "none",
    stroke: "#1a3173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7822",
    "data-name": "Path 7822",
    d: "M5,7l.987,11.85a1.975,1.975,0,0,0,1.975,1.975h7.9a1.975,1.975,0,0,0,1.975-1.975L18.825,7",
    transform: "translate(1704.088 450.063)",
    fill: "none",
    stroke: "#1a3173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7823",
    "data-name": "Path 7823",
    d: "M9,6.95V3.987A.987.987,0,0,1,9.987,3h3.95a.987.987,0,0,1,.987.987V6.95",
    transform: "translate(1704.037 450.113)",
    fill: "none",
    stroke: "#1a3173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3d12adc9cb8491ec0f14d50ce73e12b9.svg";
export { ForwardRef as ReactComponent };